module.exports = __webpack_public_path__ + "img/arrow-ticket.90b53496.png";